
'use client';

import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function ContactPageAnimator() {

  useEffect(() => {
    const timer = setTimeout(() => {
        const heroTl = gsap.timeline({
            scrollTrigger: {
                trigger: '#contact-hero',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });

        heroTl
            .to('.gsap-contact-hero-title', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', delay: 0.2 })
            .to('.gsap-contact-hero-subtitle', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6");
        
        const contentTl = gsap.timeline({
            scrollTrigger: {
                trigger: '#contact-content',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });

        contentTl
            .to('.gsap-contact-details', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', delay: 0.2 })
            .to('.gsap-contact-map', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6")
            .to('.gsap-contact-form', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6");

    }, 0);


    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return null;
}
